import { CommonPurchaseTaxes } from '../purchase-taxes'

export const UnitedStatesPurchaseTaxes = { ...CommonPurchaseTaxes }
